import qs from 'qs';
import { win } from '@wix/cashier-common/dist/src/utils/win';
import { isBooleanStr } from './isBooleanStr';

export const parseQueryParams = <T>(params: {
  validQueryParamNames: (keyof T)[];
  defaultQueryParams?: Partial<T>;
}): T => {
  const queryParams = qs.parse(win.location.search.slice(1));
  const validQueryParams = {};

  for (const queryParamName of Object.keys(queryParams)) {
    if ((params.validQueryParamNames as string[]).includes(queryParamName)) {
      const value = queryParams[queryParamName];

      validQueryParams[queryParamName] = isBooleanStr(value) ? value === 'true' : value;
    }
  }

  return {
    ...params.defaultQueryParams,
    ...(validQueryParams as T),
  };
};
